import { render, staticRenderFns } from "./transferstatus.vue?vue&type=template&id=1beb4884&scoped=true&"
import script from "./transferstatus.vue?vue&type=script&lang=js&"
export * from "./transferstatus.vue?vue&type=script&lang=js&"
import style0 from "./transferstatus.vue?vue&type=style&index=0&id=1beb4884&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1beb4884",
  null
  
)

export default component.exports